import React from 'react';
import {Link} from 'react-router';
import './DepartmentContextHeader.styl';

export default class DepartmentContextHeader extends React.PureComponent {
  render() {
    const {department} = this.props;
    return (
      <div className="department-context-header">
        <div>
          <div className="description">
            Select {this.props.modelLabel.toLowerCase()} profile for department
          </div>
          <Link to={`/admin/departments/edit/${department.id}`}>{department.name}</Link>
        </div>
        <Link to={`/admin/departments/edit/${department.id}`}>Cancel</Link>
      </div>
    );
  }
}
